module.exports = __webpack_public_path__ + "img/hotel.be8bc782.svg";